import { getOr } from 'lodash/fp';

const windowsContainInvalidConfigurations = (state, { designId, windowNames }) => ({
  ...state || {},
  designs: {
    ...getOr({}, 'designs')(state),
    [designId]: {
      ...getOr({}, `designs.${designId}`)(state),
      showWindowsWithInvalidConfigurationsModal: true,
      windowsWithInvalidConfigurations: windowNames,
    },
  },
});


export default windowsContainInvalidConfigurations;
